export default "__VITE_ASSET__BBrTTHMD__"